import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-11/task-02";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "Based on the figure below, match the columns, connect the elements</br>to their correct names by dragging a line from point to point",
  description: "Connect with lines.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/11/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
